import { findIndex } from 'lodash'

export default class Vulnerability {

  constructor(vulnerability = {}) {
    this.id = vulnerability.id || null,
    this.cvid = vulnerability.cvid || null
    this.cvss = vulnerability.cvss || 0
    this.description = vulnerability.description || ''
    this.recommendation = vulnerability.recommendation || ''
    this.references = vulnerability.references || ''
    this.pocs = vulnerability.pocs || []
    this.distributions = vulnerability.distributions || []
    this.default_exposure = vulnerability.default_exposure || null
    this.requires_poc = vulnerability.requires_poc || false
    this.proof_of_concept = vulnerability.proof_of_concept || null
  }

  mutations() {
    return {
      setVulnerability: (state, vulnerability) => state.vulnerability = new Vulnerability(vulnerability),
      setDistributions: (state, distros) => state.vulnerability.distributions = distros,
      setPoc: (state, payload) => state.vulnerability.proof_of_concept = payload,
      removeVulnerbility: (state, distroId) => {
        let index = findIndex(state.vulnerability.distributions, distro => distro.id === distroId)
        state.vulnerability.distributions.splice(index, 1)
      },
      updateCvid: (state, payload) => state.vulnerability.cvid = payload,
      updateCvss: (state, payload) => state.vulnerability.cvss = payload,
      updateSummary: (state, payload) => state.vulnerability.description = payload,
      updateRecommendation: (state, payload) => state.vulnerability.recommendation = payload,
      toggleDefaultExposure: (state) => state.vulnerability.default_exposure = !state.vulnerability.default_exposure,
      toggleRequiredPoc: (state) => state.vulnerability.requires_poc = !state.vulnerability.requires_poc,
    }
  }
}